import React, { useEffect, useContext } from "react";
import { Redirect } from "react-router-dom";

const index = props => {
  return props.children;
};

export default index;
